import type { ReactNode } from "react";
import { Button, Dialog, vars } from "@pack-it-up/ui-web";
import { useStores } from "../../app/AppContext.js";

export const SignOutModal = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}): ReactNode => {
  const { auth } = useStores();

  const onConfirm = (): void => {
    void auth.getState().signOut();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Sign out?"
      compact
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm}>
            Sign out
          </Button>
        </>
      }
    >
      <p style={{ margin: 0, fontSize: vars.font.sizeSm, color: vars.color.textMuted }}>
        You'll need to sign back in to view your trips.
      </p>
    </Dialog>
  );
};
